import React, { forwardRef, Ref } from "react"
import { Button, ButtonProps } from "dash-styled"

type Props = Omit<ButtonProps, "color" | "variant">

export const FlatButton = forwardRef(
    (
        { className, size = "xs", ...props }: Props,
        ref: Ref<HTMLButtonElement>
    ) => (
        <Button
            ref={ref}
            color="plain"
            variant="contained2"
            size={size}
            className={`shadow-none ${props.disabled ? "opacity-50" : ""} ${
                className ?? ""
            }`}
            {...props}
        />
    )
)
